module.exports = __webpack_public_path__ + "static/img/RO@3x.ab41c9f2.jpg";